import PopupBasic from 'src/game/components/popups/PopupBasic';
import i18n from 'src/lib/i18n/i18n';
import uiConfig from 'src/lib/ui/config';
import ButtonScaleViewWithText from 'src/lib/ui/components/ButtonScaleViewWithText';
import View from '@play-co/timestep-core/lib/ui/View';
import { ImageScaleView, ImageSliceView } from '@play-co/timestep-core/ui';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import sounds from 'src/lib/sounds';
import { Avatar } from '../components/shared/Avatar';

import { AssetGroup } from '@play-co/timestep-core';

type Friend = {
  name: string;
  photo: string;
};

type CloseHandler = (result: boolean) => void;
const ui = uiConfig.buruburu.invite.confirm;

export default class PopupConfirmInvite extends PopupBasic {
  private close: CloseHandler;
  private name: LangBitmapFontTextView;
  private photo: Avatar;

  constructor(opts: { superview: View; close: CloseHandler }) {
    super({
      superview: opts.superview,
      close: () => opts.close(false),
      ...ui.popup,
      tracking: { feature: 'invite', $subFeature: 'popup-confirminvite' },
      titleIcon: {
        image: 'assets/ui/friends/friend_referral_icon.png',
      },
    });

    this.close = opts.close;
    this.buttonClose.removeFromSuperview();

    this.message.updateOpts({
      ...ui.message,
      width: this.box.style.width - 2 * ui.message.x,
    });

    this.box.addSubview(
      new ImageScaleView({
        ...ui.underline,
        width: this.message.style.width,
      }),
    );

    const friendPanel = this.box.addSubview(
      new ImageSliceView(uiConfig.buruburu.invite.confirm.friendPanel),
    );

    this.photo = friendPanel.addSubview(
      new Avatar({
        ...ui.icon,
        centerOnOrigin: false,
      }),
    );

    this.name = friendPanel.addSubview(new LangBitmapFontTextView(ui.name));

    // notice
    this.box.addSubview(
      new LangBitmapFontTextView({
        ...ui.notice,
        width: this.box.style.width - 2 * ui.message.x,
        localeText: () => i18n('social.invite.referral.notice'),
      }),
    );

    this.box.addSubview(
      new ButtonScaleViewWithText({
        ...ui.cancelButton,
        localeText: () => i18n('basic.cancel'),
        onClick: async () => {
          sounds.sfx.play('cancel');
          return opts.close(false);
        },
        tracking: {
          feature: 'invite',
          $subFeature: 'popup-confirminvite-cancel',
        },
      }),
    );

    this.box.addSubview(
      new ButtonScaleViewWithText({
        ...ui.okButton,
        localeText: () => i18n('basic.okay'),
        onClick: async () => {
          sounds.sfx.play('ok');
          return opts.close(true);
        },
        tracking: { feature: 'invite', $subFeature: 'popup-confirminvite-ok' },
      }),
    );
  }

  protected getAssetsGroup() {
    return new AssetGroup(['assets/ui/friends/friend_referral_icon.png']);
  }

  public init({ name, photo }: Friend) {
    super.init({
      title: i18n('social.invite.referral.title'),
      message: i18n('social.invite.referral.confirm'),
    });

    this.name.localeText = () => name;
    this.photo.updateImage(photo);
  }
}
